<ng-container *transloco="let t; prefix: 'shared.property-card-item'">

  <!-- Use [routerLink] if newWindow is false -->
  <a *ngIf="isClickable && !newWindow && propertySummary?.code"
    [routerLink]="[localizeRoute('/properties/' + propertySummary!.code, envInjector)]"
    class="p-4 flex-col flex md:flex-row gap-4 rounded-lg overflow-hidden bg-white md:hover:shadow-[0_0_12px_rgba(0,0,0,0.2)] transition-all relative h-full cursor-pointer"
    [ngClass]="{'border border-gray-500 ring-1 ring-green-100/[.55] ring-inset shadow-[0_0_12px_rgba(0,0,0,0.2)]': withBorder || focus,}">
    <ng-container *ngTemplateOutlet="tileContent" />
  </a>

  <!-- Use [href] if newWindow is true -->
  <a *ngIf="isClickable && newWindow && propertySummary?.code"
    [href]="activeLang + '/properties/' + propertySummary!.code" target="_blank"
    class="p-4 flex-col flex md:flex-row gap-4 rounded-lg overflow-hidden bg-white md:hover:shadow-[0_0_12px_rgba(0,0,0,0.2)] transition-all relative h-full cursor-pointer"
    [ngClass]="{'border border-gray-500 ring-1 ring-green-100/[.55] ring-inset shadow-[0_0_12px_rgba(0,0,0,0.2)]': withBorder || focus,}">
    <ng-container *ngTemplateOutlet="tileContent" />
  </a>

  <ng-template #tileContent>
    <div class="rounded-lg md:aspect-[270/180] aspect-[32/22] relative overflow-hidden flex-1 md:max-w-[250px]">

      <picture>
        <img [src]="this.cardImage" [alt]="propertySummary?.defaultPhoto?.altText ?? 'cover photo'"
          class="object-cover object-center w-full h-full img-disable-context" (error)="onImageError()">
      </picture>
      @if (propertySummary?.isSold) {
      <div
        class="backdrop-blur-sm h-full w-full absolute top-0 flex justify-center items-center rounded-lg overflow-hidden">
        <img src="./assets/img/keys.svg" alt="" />
      </div>
      <div class="sold-banner">SOLD</div>
      }
      <div class="absolute inset-0 flex flex-col justify-between items-start overflow-hidden">
        <div class="flex gap-2 p-3 flex-wrap">
          <div *ngIf="propertySummary?.auctionRound && !propertySummary?.isSold"
            class="py-1 px-2 flex items-center justify-center rounded-full bg-[#3B61C1] text-white text-[0.625rem] font-bold w-fit leading-none whitespace-nowrap">
            {{ t("tags.auction") }}
          </div>
          <div *ngIf="propertySummary?.isSponsored && !propertySummary?.isSold"
            class="py-1 px-2 flex items-center justify-center rounded-full bg-[#DC7312] text-white text-[0.625rem] font-bold w-fit leading-none whitespace-nowrap">
            {{ t("tags.sponsored") }}
          </div>
          <div *ngIf="propertySummary?.isExclusive && !propertySummary?.isSold"
            class="py-1 px-2 gap-[6px] flex items-center justify-center rounded-full bg-[#059B9C] text-white text-[0.625rem] font-semibold w-fit leading-none whitespace-nowrap">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 5.12333V9.74463C10 9.8861 9.87618 10 9.72416 10H8.78928C8.63647 10 8.51266 9.88538 8.51266 9.74463V5.3446C8.51266 5.28366 8.48915 5.22417 8.44526 5.17774L5.20884 1.7027C5.09835 1.58445 4.90087 1.58445 4.79038 1.7027L1.55395 5.17774C1.51085 5.22417 1.48656 5.28366 1.48656 5.3446V8.65569C1.48656 8.79716 1.61038 8.91106 1.76318 8.91106H4.01144C4.16425 8.91106 4.28806 8.79643 4.28806 8.65569V5.8713C4.28806 5.72983 4.41188 5.61521 4.56469 5.61521H5.44315C5.59596 5.61521 5.71977 5.72983 5.71977 5.8713V9.74391C5.71977 9.88537 5.59596 9.99928 5.44315 9.99928H0.276624C0.123815 9.99928 0 9.88465 0 9.74391V5.12261C0 5.05949 0.0250764 4.99855 0.0705274 4.95139L4.79429 0.084881C4.904 -0.0282937 5.09521 -0.0282937 5.20492 0.084881L9.92869 4.95212C9.97414 4.99927 9.99922 5.06021 9.99922 5.12333H10Z"
                fill="white" />
            </svg>
            <span>{{ t("tags.exclusive") }}</span>
          </div>
          <div *ngIf="propertySummary?.isHot && !propertySummary?.isSold"
            class="py-1 px-2 flex items-center justify-center rounded-full bg-[#D93535] text-white text-[0.625rem] font-semibold w-fit leading-none whitespace-nowrap">
            <i class="icon-fire-alt mr-1"></i>
            <span>{{ t("tags.isHot") }}</span>
          </div>
        </div>
        <div *ngIf="propertySummary?.preApproved == 'Approved' && !propertySummary?.isSold"
          class="bg-[#037079CC] flex justify-center p-[6px] gap-[6px] w-full items-center backdrop-blur-sm rounded-b-lg overflow-hidden">
          <span class="text-white text-[10px] leading-none font-bold block">{{
            t("tags.preApprovedBy")
            }}</span>
          <img src="{{'../../../../assets/svgs/nbg-logo' + (activeLang === 'el' ? '-white' : '') + '.svg'}}"
            alt="Brand Logo" class="w-[66px] object-cover object-center img-disable-context" />
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-between flex-1">
      <div>
        <div class="flex justify-between items-center">
          <div>
            <h4 *ngIf="propertySummary?.title" class="text-black h4 leading-tight line-clamp-1">
              {{ propertySummary?.title }}
            </h4>
            <h5 *ngIf="propertySummary?.address?.prefecture" class="text-sm font-light leading-tight mb-3">
              {{ propertySummary?.address?.prefecture }}
            </h5>
          </div>
          @if (showFavorite) {
          <button *ngIf="!propertySummary?.isSold" (click)="toggleFavorite($event)"
            class="p-4 rounded-full w-10 h-10 flex items-center self-start justify-center bg-gray-100 text-primary-600 hover:bg-gray-200 transition-colors">
            <i [ngClass]="
                  propertySummary?.isFavorite
                    ? 'icon-heart-filled text-primary'
                    : 'icon-heart-line'
                "></i>
          </button>
          }
        </div>
        <div class="flex justify-between">
          <h5 *ngIf="propertySummary?.price" class="text-black text-lg font-semibold">
            €{{ propertySummary?.price | number }}
            <!-- <span *strikeThroughPrice="propertySummary" class="line-through text-sm text-[#003841]/20">€{{
              propertySummary?.previousPrice|
              number }}</span> -->
          </h5>
          <div *ngIf="
              propertySummary?.auctionRound && propertySummary?.auctionRound != 0
            " class="text-[#3B61C1] text-sm font-semibold block flex items-center gap-2">
            @switch (propertySummary?.auctionRound) {
            @case (1) {
            {{ t("auctionRound.first") }}
            }
            @case (2) {
            {{ t("auctionRound.second") }}
            }
            @case (3) {
            {{ t("auctionRound.third") }}
            }
            @case (4) {
            {{ t("auctionRound.fourth") }}
            }
            @default {}
            }
            {{ t("label.round") }}
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-x-2 gap-y-3 whitespace-nowrap text-sm leading-none">
        <div class="flex gap-1">
          <i class="icon-needs-renovation flex justify-center items-center text-sm"></i>{{
          propertySummary?.constructionYear ?? "-" }}
        </div>
        <div *ngIf="propertySummary?.floor" class="flex gap-1">
          <i class="icon-stairs flex justify-center items-center text-sm"></i>{{ propertySummary?.floor | number }}
          <span class="truncate">{{
            propertySummary?.floor == 0 ? t("label.zero") : t("label.floorsufix")
            }}</span>
        </div>
        <div *ngIf="propertySummary?.numberOfRooms" class="flex gap-1">
          <i class="icon-bed flex justify-center items-center text-sm"></i>{{ propertySummary?.numberOfRooms }}
          <span class="truncate">{{ t("label.bedrooms") }}</span>
        </div>
        <div *ngIf="
            propertySummary?.numberOfBathrooms &&
            propertySummary?.numberOfBathrooms != 0
          " class="flex gap-1">
          <i class="icon-bathroom flex justify-center items-center text-sm"></i>{{ propertySummary?.numberOfBathrooms }}
          <span class="truncate">{{
            propertySummary!.numberOfBathrooms! > 1
            ? t("label.bathrooms")
            : t("label.bathroom")
            }}</span>
        </div>
      </div>
      <!-- <div *ngIf="propertySummary?.isSold" class="property-sold-wrapper z-0">
        <div class="sold-icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12 3.60039C9.77221 3.60039 7.63563 4.48539 6.06033 6.06069C4.48502 7.636 3.60002 9.77257 3.60002 12.0004C3.60002 13.1035 3.8173 14.1958 4.23944 15.2149C4.66158 16.2341 5.28032 17.1601 6.06033 17.9401C6.84034 18.7201 7.76635 19.3388 8.78548 19.761C9.80462 20.1831 10.8969 20.4004 12 20.4004C13.1031 20.4004 14.1954 20.1831 15.2146 19.761C16.2337 19.3388 17.1597 18.7201 17.9397 17.9401C18.7197 17.1601 19.3385 16.2341 19.7606 15.2149C20.1828 14.1958 20.4 13.1035 20.4 12.0004C20.4 9.77257 19.515 7.636 17.9397 6.06069C16.3644 4.48539 14.2278 3.60039 12 3.60039ZM5.2118 5.21217C7.01215 3.41182 9.45395 2.40039 12 2.40039C14.5461 2.40039 16.9879 3.41182 18.7882 5.21217C20.5886 7.01251 21.6 9.45431 21.6 12.0004C21.6 13.2611 21.3517 14.5094 20.8693 15.6742C20.3868 16.8389 19.6797 17.8972 18.7882 18.7886C17.8968 19.6801 16.8385 20.3872 15.6738 20.8696C14.5091 21.3521 13.2607 21.6004 12 21.6004C10.7393 21.6004 9.49099 21.3521 8.32626 20.8696C7.16154 20.3872 6.10324 19.6801 5.2118 18.7886C4.32036 17.8972 3.61323 16.8389 3.13078 15.6742C2.64834 14.5094 2.40002 13.2611 2.40002 12.0004C2.40002 9.45431 3.41145 7.01251 5.2118 5.21217ZM8.57324 8.95181C8.67287 8.75256 8.92164 8.40039 9.37502 8.40039C9.82841 8.40039 10.0772 8.75256 10.1768 8.95181C10.2945 9.18716 10.35 9.47034 10.35 9.75039C10.35 10.0304 10.2945 10.3136 10.1768 10.549C10.0772 10.7482 9.82841 11.1004 9.37502 11.1004C8.92164 11.1004 8.67287 10.7482 8.57324 10.549C8.45557 10.3136 8.40002 10.0304 8.40002 9.75039C8.40002 9.47034 8.45557 9.18716 8.57324 8.95181ZM13.8232 8.95181C13.9229 8.75256 14.1716 8.40039 14.625 8.40039C15.0784 8.40039 15.3272 8.75256 15.4268 8.95181C15.5445 9.18716 15.6 9.47034 15.6 9.75039C15.6 10.0304 15.5445 10.3136 15.4268 10.549C15.3272 10.7482 15.0784 11.1004 14.625 11.1004C14.1716 11.1004 13.9229 10.7482 13.8232 10.549C13.7056 10.3136 13.65 10.0304 13.65 9.75039C13.65 9.47034 13.7056 9.18716 13.8232 8.95181ZM10.0563 14.784C10.6784 14.5276 11.3453 14.3972 12.0182 14.4004C13.365 14.4037 14.6557 14.941 15.6068 15.8947C15.8408 16.1293 15.8404 16.5092 15.6057 16.7432C15.3711 16.9772 14.9912 16.9767 14.7572 16.7421C14.0303 16.0133 13.044 15.6027 12.0147 15.6004L12.0131 15.6004C11.4988 15.5979 10.9891 15.6975 10.5135 15.8935C10.038 16.0895 9.60606 16.3779 9.24284 16.7421C9.00883 16.9767 8.62893 16.9772 8.39431 16.7432C8.15969 16.5092 8.1592 16.1293 8.39321 15.8947C8.86859 15.4181 9.43387 15.0405 10.0563 14.784Z"
              fill="#0D5E62" />
          </svg>
        </div>
        <div class="flex flex-col items-center">
          <p class="font-bold text-secondary-800 text-xl">{{t('sold.title')}}</p>
          <p class='text-black'>{{t('sold.price')}} €125,000</p>
        </div>
        <button type="button" class="btn-text" (click)="toggleFavorite($event)"><span>{{t('sold.button')}}</span></button>
      </div> -->
    </div>
  </ng-template>
</ng-container>